export default __webpack_public_path__ + "static/media/noDataIcon.ee05bc1b.svg";